import styled from 'styled-components';
import { Flex } from '../../../GlobalComponents/Flex';

export type BalanceDueProps = React.HTMLAttributes<HTMLDivElement> & {
	balanceDue: number;
};

export const BalanceDue: React.FC<BalanceDueProps> = ({ balanceDue }) => {
	return (
		<Flex
			$flexDirection="row"
			$placeContent="center space-between"
			$padding="10px 0"
		>
			<Text>Balance Due</Text>
			<Flex $flexDirection="row" $width="unset">
				<Text>
					$
					{typeof balanceDue === 'number'
						? balanceDue.toFixed(2)
						: balanceDue}
				</Text>
			</Flex>
		</Flex>
	);
};

const Text = styled.div`
	font-weight: 500;
	font-size: 24px;
	color: #f47920;
`;
